import Link from 'next/link';
import type { MarketingNavGroup } from './content';

/** Desktop and tablet Solutions menu. */
export function NavMenuPanel({
  groups,
  onNavigate,
}: {
  groups: Array<MarketingNavGroup>;
  onNavigate: () => void;
}) {
  return (
    <div className="grid w-full gap-10 pt-12 pb-16 md:grid-cols-2 md:gap-16 md:pt-20">
      {groups.map((group) => (
        <NavGroup key={group.title} group={group} onNavigate={onNavigate} />
      ))}
    </div>
  );
}

function NavGroup({
  group,
  onNavigate,
}: {
  group: MarketingNavGroup;
  onNavigate: () => void;
}) {
  return (
    <div>
      <p className="bg-marketing-panel text-marketing-panel-fg rounded-sm py-1.5 text-center text-[clamp(0.875rem,1.1vw,1rem)] leading-tight font-semibold [letter-spacing:-0.02em]">
        {group.title}
      </p>
      <ul className="border-marketing-border mt-6 border-t">
        {group.links.map((link) => (
          <li key={link.label} className="border-marketing-border border-b">
            <Link
              href={link.href}
              onClick={onNavigate}
              className="text-marketing-fg hover:bg-marketing-accent-subtle focus-visible:outline-marketing-accent-strong block py-1.5 text-sm [letter-spacing:-0.01em] transition-colors duration-250 outline-none focus-visible:outline-2 focus-visible:-outline-offset-2"
            >
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
